import { type CSSProperties, type FC } from "react";

import ListCellContent, { type ListCellItem } from "./ListCellContent.js";
import { nonBreakingSpace } from "@/settings/settings.js";
import { type IAgGridCellProps } from "@/ui-modules/core/grid/cell-base-interfaces.ts";

interface ITextCellProps {
  style?: CSSProperties;
  classname?: string;
  tooltip?: string;
}

/**
 * Converts a simple text string into {@link ListCellItem}s.
 */
const TextCell: FC<IAgGridCellProps & ITextCellProps> = (props) => {
  const finalValue = props.valueFormatted || props.value;
  const multiValues: string[] = finalValue instanceof Array ? finalValue : [finalValue];

  // SEL6-2659: Make sure null values result in empty lines in the table cell by translating them to &nbsp (\u00A0);
  const items: ListCellItem[] = multiValues.map((v) => ({
    value: v == undefined || v?.trim?.() == "" ? nonBreakingSpace : v,
    tooltip: props.tooltip || v || nonBreakingSpace,
  }));

  return <ListCellContent items={items} colDef={props.colDef} context={props.context} style={props.style} />;
};

export default TextCell;
